import { get } from './axios.js'


//是否显示白条弹窗 
export const newAndOldShopIsPopUp = p => get(`/popup/newAndOldShopIsPopUp`, p);

// 获取maToken
export const getMAToken = p => get('/popup/getMAToken', p); 

// 获取onceToken
export const getOnceToken = p => get('/popup/getOnceToken', p); 